module.exports = __webpack_public_path__ + "img/Icon_info_Plus.8adaeac2.png";